class TextHelper {
    checkTextLength = (text, maxLength, seperator) => {
        if (text.length > maxLength) {
            return `${text.substring(0, maxLength)}${seperator || '...'}`
        }
        return text
    }
}

export default new TextHelper()
